import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { css } from "@emotion/react";

import useAuth from "../../utils/useAuth";
import { responsive } from "../../utils/style";

export default () => {
  let { isStaff, isAdmin } = useAuth();

  return (
    <Container>
      <Background>
        <Title>โค้ดสำหรับการเปลี่ยนรหัสผ่าน</Title>
        <ActionGroup>
          {isStaff && (
            <Action to={`/genCodePassword/student`} role="student">
              <Label>สามเณร</Label>
            </Action>
          )}
          {isAdmin && (
            <Action to={`/genCodePassword/staff`} role="staff">
              <Label>พระสงฆ์ พระอาจารย์ ครูฆราวาส</Label>
            </Action>
          )}
        </ActionGroup>
      </Background>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;
`;
const Background = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1144px;
  background-color: white;
  padding: 40px 187px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.tablet(css`
    padding: 40px 24px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px;
  `)}
`;
const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  color: #058459;
  margin-top: 40px;
`;
const ActionGroup = styled.div`
  margin-top: 24px;
  width: 100%;
`;
const Action = styled(Link)`
  width: 770px;
  height: 100px;
  background: #e7eaee;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.role === "student" ? "#FFA226" : "#FC6B4B")};

  &:hover {
    cursor: pointer;
  }

  ${responsive.tablet(css`
    width: 100%;
  `)}
`;
const Label = styled.span`
  font-style: normal;
  font-size: 28px;
  line-height: 34px;
  color: #ffffff;
  margin: 0;
  font-weight: 700;

  > br {
    display: none;
  }

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;
    font-weight: 400;
  `)}
`;
